module.exports = __webpack_public_path__ + "img/image_023.ed97266f.jpeg";